import { IProblemContact, IProblem } from '../models/Problems.interfaces';
import ProblemsClient from '../utils/client/ProblemsClient';

export const getListProblems = () => {
    return ProblemsClient.get('/problems');
};

export const createNewProblem = ({ productId, customerId, motiveId, contactWrittenId, contactCallId }: IProblem) => {
    return ProblemsClient.post('/problems', { productId, customerId, motiveId, contactWrittenId, contactCallId });
};

export const getProblemById = ({ problemId }: { problemId: string }) => {
    return ProblemsClient.get(`/problems/${problemId}`);
};

export const getEventsProblemById = ({ problemId }: { problemId: string }) => {
    return ProblemsClient.get(`/problems/${problemId}/events`);
};

export const getListContactsProblems = () => {
    return ProblemsClient.get('/problems/contacts');
};

export const getListMotivesById = ({ categoryId }: { categoryId: string }) => {
    return ProblemsClient.get(`/problems/categories?id=${categoryId}`);
};

export const getListMotives = () => {
    return ProblemsClient.get(`/problems/categories`);
};

export const getListTasksProblemsById = ({ problemId }: { problemId: string }) => {
    return ProblemsClient.get(`/problems/${problemId}/tasks`);
};

export const getTroubleticketById = ({ troubleTicketId }: { troubleTicketId: string }) => {
    return ProblemsClient.get(`/problems/troubleticket/${troubleTicketId}`);
};

export const getTroubleticketTask = ({ troubleTicketId }: { troubleTicketId: string }) => {
    return ProblemsClient.get(`/problems/troubleticket/${troubleTicketId}/tasks`);
};

export const getWorkById = ({ workOrderId }: { workOrderId: string }) => {
    return ProblemsClient.get(`/problems/work/${workOrderId}`);
};

export const getProblemsWorkTasks = ({ workOrderId }: { workOrderId: string }) => {
    return ProblemsClient.get(`/problems/work/${workOrderId}/tasks`);
};

export const getShippingById = ({ shippingOrderId }: { shippingOrderId: string }) => {
    return ProblemsClient.get(`/problems/shipping/${shippingOrderId}`);
};

export const getShippingOrderZelerisById = ({
    shippingOrderId,
    orderId,
}: {
    shippingOrderId: string;
    orderId: string;
}) => {
    return ProblemsClient.get(`/problems/shipping/${shippingOrderId}/order/${orderId}`);
};

export const getShippingOrderTask = ({ shippingOrderId }: { shippingOrderId: string }) => {
    return ProblemsClient.get(`/problems/shipping/${shippingOrderId}/tasks`);
};

export const createNewContact = ({ id, type, favourite, value }: IProblemContact) => {
    return ProblemsClient.post('/problems/contacts', { id, type, favourite, value });
};

export const getMotivesProblemById = ({ productId }: { productId: string }) => {
    return ProblemsClient.get(`/problems/motives/${productId}`);
};

export const cancelProblemById = ({ problemId }: { problemId: string }) => {
    return ProblemsClient.put(`/problems/${problemId}/cancel`);
};

export const reiterateProblemById = ({ problemId }: { problemId: string }) => {
    return ProblemsClient.put(`/problems/${problemId}/reiterate`);
};

export const resumeProblemById = ({ problemId }: { problemId: string }) => {
    return ProblemsClient.put(`/problems/${problemId}/resume`);
};

export const validateProblemById = ({ problemId, conformity }: { problemId: string; conformity: boolean }) => {
    return ProblemsClient.put(`/problems/${problemId}/validate`, { conformity });
};

export const getProblemDialogById = ({ problemId, dialogId }: { problemId: string; dialogId: string }) => {
    return ProblemsClient.get(`/problems/${problemId}/diagnose/dialog/${dialogId}`);
};

export const nextQuestion = ({
    dialogId,
    problemId,
    responseId,
}: {
    dialogId: string;
    problemId: string;
    responseId: string;
}) => {
    return ProblemsClient.put(`/problems/${problemId}/diagnose/continue`, { dialogId, responseId });
};

export const nextDialog = ({ dialogId }: { dialogId: string }) => {
    return ProblemsClient.put(`/problems/${dialogId}/diagnose/continue`);
};
